import { normalQueryTypes } from '@ow/utils'

export const filterSpec = {
  // 支持为空、不为空查询
  queryTypes: ['isNull', 'notNull'].map((p) => normalQueryTypes[p]),
}

export const config = {
  hint: '请输入',
  slug: `images${Math.round(Math.random() * 100)}`,
  span: 1,
  type: 'media',
  intro: '请选择要上传的文件',
  title: '图片',
  render: 'big',
  default: {},
  maxSize: 500,
  readonly: false,
  required: false,
  description: '备注显示区域：进行详细的解释说明。',
  allowedTypes: [
    '.gif',
    '.png',
    '.jpg',
    '.jpeg',
    '.mp4',
    '.flv',
    '.f4v',
    '.webm',
    '.mov',
    '.3gp',
    '.avi',
    '.wmv',
    '.mp3',
    '.wav',
    '.amr',
    '.m4a',
  ],
  allowedAppImport: true,
  allowedWebImport: true,
  hiddenWhenCreate: false,
  uploadQuantities: 20,
  showType: 'show',
}
